import React, { Fragment } from 'react';
import { Card, Row, Col, Button } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import styles from './Card.less';

@connect(({ merchantBusinessMy, loading }) => ({
  loading: loading.effects['merchantBusinessMy/fetchCardInfo'],
  cardInfo: merchantBusinessMy.cardInfo,
  auditStatusArr: merchantBusinessMy.auditStatusArr,
}))
export default class CardEnterpriseInfoCard extends React.Component {
  constructor(props) {
    super(props);

    this.renderBankCard = this.renderBankCard.bind(this);
    this.handelAddbankCard = this.handelAddbankCard.bind(this);
    this.renderAuditStatusCard = this.renderAuditStatusCard.bind(this);
    this.handelVerifyMoney = this.handelVerifyMoney.bind(this);
  }

  handelAddbankCard() {
    // 跳转二级页
    this.props.dispatch(routerRedux.push('/merchant/business/my/add-enterprise-bank-card'));
  }

  handelVerifyMoney() {
    this.handelAddbankCard();
  }

  renderBankCard() {
    const { status, bankNo } = this.props.cardInfo;

    let button = null;

    if (status === 0) {
      button = (
        <Button ghost type="primary" icon="plus" onClick={this.handelAddbankCard}>
          绑定银行卡
        </Button>
      );
    } else if (status === 2) {
      button = (
        <Button ghost type="primary" onClick={this.handelAddbankCard}>
          更换银行卡
        </Button>
      );
    }

    return (
      <div className="bank-card-content">
        {bankNo}
        {button}
      </div>
    );
  }

  // 审核状态
  renderAuditStatusCard() {
    const { status } = this.props.cardInfo;
    const { auditStatusArr } = this.props;

    switch (status) {
      case 1:
      case 3:
        return (
          <div className="bank-card-content">
            {auditStatusArr[status]}
            <Button ghost type="primary" onClick={this.handelVerifyMoney}>
              验证资金
            </Button>
          </div>
        );
      default:
        return <div className="bank-card-status">{auditStatusArr[status]}</div>;
    }
  }

  render() {
    const { labelLayout, contentLayout, loading } = this.props;
    const { name, idNo, status } = this.props.cardInfo;

    return (
      <Fragment>
        <Card title="企业资料" loading={loading} className={styles.root} bordered={false}>
          <Row>
            <Col {...labelLayout}>公司名称：</Col>
            <Col {...contentLayout}>{name}</Col>
          </Row>

          <Row>
            <Col {...labelLayout}>统一社会信用代码：</Col>
            <Col {...contentLayout}>{idNo}</Col>
          </Row>

          <Row>
            <Col {...labelLayout} className="bank-card-label">
              银行卡号：
            </Col>
            <Col {...contentLayout}>{this.renderBankCard()}</Col>
          </Row>

          {status !== undefined && (
            <Row>
              <Col {...labelLayout} className="bank-card-label">
                审核状态：
              </Col>
              <Col {...contentLayout}>{this.renderAuditStatusCard()}</Col>
            </Row>
          )}
        </Card>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Card/CardEnterpriseInfo.js